import apiClient from "../../../utilities/apiClient";
import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";

export const get_orders = (page, rowsPerPage, search) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_id = user.vendor_id;

  return apiClient.get(
    `${
      apiClient.Urls.order_numbers
    }?vendor_id=${vendor_id}&page=${page}&per_page=${rowsPerPage}&search=${
      search || ""
    }`,
    "",
    true
  );
};

export const view_OrderDetails = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.view_order_details}/${payload}`,
    "",
    true
  );
};

export const approve_order = (payload) => {
  return apiClient.patch(
    `${apiClient.Urls.order_approve}/${payload.order_id}`,
    payload,
    true
  );
};
export const create_invoice = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.createInvoice}`,
    payload,
    true,
    "file"
  );
};
export const get_creditDebitNote = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_id = user.vendor_id;
  return apiClient.get(
    `${apiClient.Urls.getCreditDebitNote}/${vendor_id}?page=${payload?.page}&per_page=${payload?.per_page}`,
    "",
    true
  );
};
